"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var BACK = 'back';
function isValidUrl(value) {
    try {
        new URL(value);
        return true;
    }
    catch (_a) {
        return false;
    }
}
var useDepositReturnLinks = function () {
    var searchParams = (0, navigation_1.useSearchParams)();
    var depositSuccessLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_SUCCESS);
    var depositCancelLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT);
    var depositErrorLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_ERROR);
    var back = searchParams.get(BACK);
    var generateFullLink = (0, react_1.useCallback)(function (link) {
        if (typeof window !== 'undefined')
            return back ? link : "".concat(window.location.origin).concat(link);
        return link;
    }, [back]);
    return (0, react_1.useMemo)(function () {
        var successURL = generateFullLink(depositSuccessLink);
        var cancelURL = generateFullLink(depositCancelLink);
        var errorURL = generateFullLink(depositErrorLink);
        return {
            success_url: isValidUrl(successURL)
                ? successURL
                : "".concat(window.location.origin, "?modal=").concat(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_SUCCESS),
            cancel_url: isValidUrl(cancelURL)
                ? cancelURL
                : "".concat(window.location.origin, "?modal=").concat(apps_shared_1.POPUP_CONSTANTS.DEPOSIT),
            fail_url: isValidUrl(errorURL)
                ? errorURL
                : "".concat(window.location.origin, "?modal=").concat(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_ERROR),
        };
    }, [
        generateFullLink,
        depositSuccessLink,
        depositCancelLink,
        depositErrorLink,
    ]);
};
exports.default = useDepositReturnLinks;
